import React, { useRef } from 'react'
import { Link } from 'gatsby'
import { useLocation } from '@reach/router'
import { menuLinks } from 'templates/layout/menu-links'
// import ServicePanel from './service-panel'
import useMenuVariation from './use-menu-variation'

// const isElementIdHovered = (targetId) => !!document.querySelector(`#${targetId}:hover`)

const DesktopMenu = ({ expectHero, bgClass, colorClass }) => {
	const { pathname } = useLocation()
	const menuContainerRef = useRef()
	// const panelRef = useRef()
	const triggerRef = useRef()
	const isPanelVisible = false
	// const [isPanelVisible, setIsPanelVisible] = useState(false)
	const shouldAutoDetect = bgClass === 'auto' && colorClass === 'auto'
	const variation = useMenuVariation(expectHero, shouldAutoDetect)

	// const serviceLinks = useMemo(() => {
	// 	const itemWithChildren = menuLinks.filter(({ children }) => Boolean(children))
	// 	// if (itemWithChildren.length === 0) {
	// 	// 	throw new Error('Where is item with children?')
	// 	// }

	// 	return itemWithChildren[0]
	// }, [])

	const buildActiveClass = (needle) =>
		pathname.indexOf(needle) === 0
			? `border-current group-hover:border-accent`
			: 'border-transparent'

	const buildColorClass = () => {
		if (isPanelVisible) {
			return 'text-black'
		}
		if (shouldAutoDetect) {
			return variation === 'light'
				? 'text-white bg-transparent'
				: 'text-black bg-white'
		}
		return colorClass + ' ' + bgClass
	}

	return (
		<nav
			ref={menuContainerRef}
			className={
				`top-0 left-0 z-20 hidden w-full lg:fixed lg:block ` + buildColorClass()
			}
		>
			<div className="relative">
				<div
					className={`relative z-[2] flex h-20 items-stretch pl-screen-step-1/2`}
				>
					{menuLinks.map((link) =>
						link?.children ? (
							<div
								className={`group mx-screen-step-1/4 px-screen-step-1/4 text-sm font-semibold hover:cursor-pointer`}
								id="menu-panel-trigger"
								ref={triggerRef}
								key={link.title}
							>
								<div
									className={
										`-mx-1 flex h-full items-center border-t-2 px-1 transition-colors duration-300 group-hover:text-accent ` +
										buildActiveClass('/services/')
									}
								>
									{link.title}
									<svg
										className={`ml-1 h-4 w-4 fill-current transition-transform duration-300 ${
											isPanelVisible ? 'rotate-90' : ''
										}`}
										viewBox="0 0 16 16"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M3 7h2v2H3V7zm4 0h2v2H7V7zm4 0h2v2h-2V7z"
											fillRule="nonzero"
										/>
									</svg>
								</div>
							</div>
						) : (
							<Link
								className={`group mx-screen-step-1/4 flex items-center px-screen-step-1/4 text-sm font-semibold`}
								to={link.url}
								key={link.url}
							>
								<div
									className={
										`-mx-1 flex h-full items-center border-t-2 px-1 !leading-none transition-colors duration-300 group-hover:text-accent ` +
										buildActiveClass(link.url)
									}
								>
									{link.title}
								</div>
							</Link>
						)
					)}

					<div className="ml-auto mr-screen-step-1/2 w-28">
						<Link
							to="/"
							className={`flex h-full w-full items-center justify-end px-screen-step-1/2 transition-colors duration-300 hover:text-accent`}
						>
							<svg
								className="w-full fill-current"
								viewBox="0 0 67 54"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M26.98 0h29.04L67 38.05 41.844 54H11.892L0 15.72z"
									fillRule="nonzero"
								/>
							</svg>
						</Link>
					</div>
				</div>

				{/* <ServicePanel
					isVisible={isPanelVisible}
					links={serviceLinks}
					ref={panelRef}
				/> */}
			</div>
		</nav>
	)
}

export default DesktopMenu
